import { Injectable } from "@angular/core";
import { OfEtat } from "../../enums/etat-of.enum";

@Injectable({
  providedIn: "root",
})
export class OfEtatService {
  constructor() {}

  static getOfEtatColor(etat: OfEtat) {
    switch (etat) {
      case OfEtat.EN_ATTENTE_PLANNIF:
        return "var(--color-on-background-alt)";
      case OfEtat.EN_ATTENTE_PROD:
        return "#43B4FF";
      case OfEtat.EN_PROD:
        return "#FF919D";
      case OfEtat.EN_ATTENTE_REINTE_PDC:
        return "#FFC66D";
      case OfEtat.EN_ATTENTE_VALIDATION:
        return "var(--shark-500)";
      case OfEtat.VALIDE:
        return "var(--color-primary)";
      case OfEtat.ANNULE:
        return "var(--color-on-error)";
    }
  }
}
